// vorgangFilter.ts — Spaltenfilter „Vorgänge“ der Kontaktliste.
//
// T-284 (Dirk, 10.10.2026): „am besten auch nach der Art filtern, wie NKG“.
// Bis dahin ein Schalter „Offene Vorgänge“ (Wert `true`). Jetzt eine Auswahl:
//  - „Alle offenen Vorgänge“ (`"true"`) — genau das bisherige Verhalten; das
//    Backend nimmt `true` und `"true"` gleich, NKG bleibt dort ausgenommen
//    (es hat in der Spalte seinen eigenen Marker).
//  - je Katalog-Art (NKG, JG, GAB, Sonstige) — nur OFFENE Vorgänge dieser Art.
//    Das Backend prüft den Wert gegen dieselbe feste Liste
//    (`apps/api/src/vorgang/vorgangArt.ts`).

import { VORGANG_ARTEN, artLangform } from "../../../data/vorgangArt";
import type { FilterWerte } from "../kontaktStandardFilter";
import type { ColumnFilterDescriptor } from "./RdColumnFilter";

/** Spalten-Id (= Filterschlüssel) der Vorgänge-Spalte. */
export const VORGANG_SPALTE = "Vorgange";

/** „Alle offenen Vorgänge“ — als String, weil die Auswahl Strings führt. */
export const ALLE_OFFENEN = "true";

export const VORGANG_FILTER_OPTIONEN: string[] = [ALLE_OFFENEN, ...VORGANG_ARTEN];

/** Beschriftung einer Option: Kürzel, wo es eine Langform gibt mit ihr. */
export function vorgangFilterLabel(wert: string): string {
  if (wert === ALLE_OFFENEN) return "Alle offenen Vorgänge";
  const lang = artLangform(wert);
  return lang && lang !== wert ? `${wert} (${lang})` : wert;
}

/** Die Arten stehen eingerückt unter „Alle offenen“ — sie sind ein Teil davon. */
export const vorgangFilterEingerueckt = (wert: string): boolean => wert !== ALLE_OFFENEN;

export const VORGANG_SPALTEN_FILTER: ColumnFilterDescriptor = {
  kind: "dropdown",
  options: VORGANG_FILTER_OPTIONEN,
  optionLabel: vorgangFilterLabel,
  optionIndent: vorgangFilterEingerueckt,
};

/**
 * Gespeicherter Wert → Wert der Auswahl. Ein Tabellenstand von vor T-284
 * trägt noch das boolesche `true` — das ist „Alle offenen“. Unbekanntes fällt weg.
 */
export function vorgangFilterWert(v: unknown): string | undefined {
  if (v === true || v === ALLE_OFFENEN) return ALLE_OFFENEN;
  return typeof v === "string" && (VORGANG_ARTEN as readonly string[]).includes(v) ? v : undefined;
}

/** Filterwerte mit normalisiertem Vorgangs-Schlüssel — die übrigen bleiben unberührt. */
export function mitVorgangFilterWert(werte: FilterWerte): FilterWerte {
  if (!(VORGANG_SPALTE in werte)) return werte;
  const { [VORGANG_SPALTE]: alt, ...rest } = werte;
  const neu = vorgangFilterWert(alt);
  return neu === undefined ? rest : { ...rest, [VORGANG_SPALTE]: neu };
}
